import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Icon10 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon9 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/Oluwole Ogunlade.jpg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/FEMI SUIT - Product Management Practice Lead.png";
import Coach1 from "../../../../../assets/images/png/courses/instructors/jelil.webp";
import SerahmercyImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/SERAHMERCY SUIT - Product Management & Design and Software Development Support Person.png";
import OmodaraImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMODARA SUIT -  Product and Digital Marketing Practice Lead.png";
import AmandaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Amanda Suit - Cybersecurity and Business Analysis and Project Management Support Person.png";

import AdeolaImage from "../../../../../assets/images/png/courses/testimonies/adeola.png";
import OttahImage from "../../../../../assets/images/png/courses/testimonies/otta.png";
import OluwabukunmiImage from "../../../../../assets/images/png/courses/testimonies/okikiowo.png";
import PaulImage from "../../../../../assets/images/png/courses/testimonies/olatoye.png";
import MoziaImage from "../../../../../assets/images/png/courses/testimonies/doris.png";
import GabrielImage from "../../../../../assets/images/png/courses/testimonies/fiona.png";
import MercyImage from "../../../../../assets/images/png/courses/testimonies/mercy.png";
import KehindeImage from "../../../../../assets/images/png/courses/testimonies/obaleye.png";
import EresabaImage from "../../../../../assets/images/png/courses/testimonies/emmanuel.png";
import OlutayoImage from "../../../../../assets/images/png/courses/testimonies/owolabi.png";
import IsaacImage from "../../../../../assets/images/png/courses/testimonies/ifeanyi.png";
import KabariImage from "../../../../../assets/images/png/courses/testimonies/sambaris.png";
import SolomonImage from "../../../../../assets/images/png/courses/testimonies/oladejo.png";
import OladeleImage from "../../../../../assets/images/png/courses/testimonies/oladele.png";
import JorshImage from "../../../../../assets/images/png/courses/testimonies/jorsh.png";
import OwoeyeImage from "../../../../../assets/images/png/courses/testimonies/owoeye.png";
import OnyedinmaImage from "../../../../../assets/images/png/courses/testimonies/onyedinma.png";
import DamilolaKImage from "../../../../../assets/images/png/courses/testimonies/damilola.png";
import OluwaseunImage from "../../../../../assets/images/png/courses/testimonies/oluwaseun.png";
import OgunrinolaImage from "../../../../../assets/images/png/courses/testimonies/ogunrionola.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import ProductMgtPreview from "../../../../../assets/images/jpeg/productMgtPreview.jpg";

export const productManagementAcceleratorAfrica = {
  id: 1,
  tag: "PM-DE SCHOOL",
  title: "Product Management and Design Bootcamp",
  description: `
    Develop the mindset, skills, and hands-on experience to think
    strategically, design thoughtfully, and execute products that make
    real impact. This program blends Product Management and Product
    Design into a single integrated learning journey, equipping you to
    solve real user problems, build meaningful products, and create a
    portfolio that demonstrates your capabilities.
    `,
  duration: "4 Months",
  durationDetail: "16-week integrated program",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/1HnlMkwR7mBOlYd05QFyeyE5mf5OSBbOg/view?usp=sharing",

  courseFormUrl: "courses/product-management-and-design-bootcamp/fill-form",

  jobTitle: "Product Manager",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: TestimonialImage,
    name: "Oluwole Ogunlade",
    role: "Growth Consultant, Cross-border Payment Processor",
    testimony: `
    I got the best experience from the Utiva Product Management 
    program, it was a hands-on learning experience as we were 
    splitted into groups and given real life business cases to 
    work on as a team. For me I enjoyed the expertises of the 
    facilitators and the quality of materials we were given. 
    Above all the community style of learning is everything.
`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Fast Track Your Career In Product Management; Learn Product Management Best Practices Live, Led by Experienced Product Leaders`,
    desc: `
    Product Managers are responsible for owning a product at every stage of
    its life cycle, bringing it from ideation to market, and ensuring
    success. Balance business viability, technical feasibility, and
    customer desire to lead products and features toward long-term
    success. Learn from leading experts in the industry and develop
    the capacity to drive successful projects. Balance business
    viability, technical feasibility,
    and customer desire to lead products and features toward
    long-term success. Learn from a seasoned expert.
    `,
  },

  heroSubtitle:
    "From problem discovery to a portfolio-ready product—built together through live classes, practical feedback and one integrated Product Management + Design journey.",

  heroHighlights: [
    "16-week integrated program (4 months)",
    "Co-delivered by PM + UI/UX experts in every session",
    "Learn Product Management and Product Design together, not as separate programs",
    "Hands-on, cross-functional learning; graduate with a real product to showcase",
  ],

  keyOutcomesHeading: "Think Like a Product Manager Design Like a UX Expert",

  keyOutcomes: [
    {
      label: "Discover",
      desc:
        "Identify and validate real user problems through research, interviews, and data-driven insights.",
    },
    {
      label: "Decide",
      desc:
        "Prioritize features, define the MVP, and make informed decisions that balance business goals and user needs.",
    },
    {
      label: "Design",
      desc:
        "Build wireframes, interactive prototypes, and high-fidelity designs grounded in user experience principles.",
    },
    {
      label: "Deliver",
      desc:
        "Execute the product lifecycle end-to-end: agile sprints, roadmaps, metrics, launch strategies, and iteration.",
    },
  ],

  curriculumHeading: "16-Week Curriculum Highlights",

  curriculumPhases: [
    {
      phaseTitle: "Foundation",
      phaseWeeks: "Weeks 1–4",
      items: [
        {
          weekLabel: "01",
          title: "Foundations of Product Development",
          desc: "PM lifecycle, Agile, Lean, Waterfall; Design vs UX/UI",
        },
        {
          weekLabel: "02",
          title: "Product Thinking & Problem Discovery",
          desc: "Validating problems, user research, early PRD",
        },
        {
          weekLabel: "03",
          title: "Product Documentation & Design Systems",
          desc: "PRDs, user stories, design system theory",
        },
        {
          weekLabel: "04",
          title: "User Flows, Wireframes & Design Systems (Practical)",
          desc: "Figma components, PM → Design handoff",
        },
      ],
    },
    {
      phaseTitle: "Build",
      phaseWeeks: "Weeks 5–10",
      items: [
        {
          weekLabel: "Week 5",
          title: "Early-Stage Prototyping & Validation",
          desc: "MVP frameworks, low-fidelity prototypes",
        },
        {
          weekLabel: "Weeks 6–7",
          title: "AI WorkLab",
          desc: "Agile sprints, Jira, AI-assisted design and research",
        },
        {
          weekLabel: "Weeks 8–10",
          title: "Strategy, Roadmaps & Mobile App Project",
          desc: "OKRs, mobile UX, final prototype",
        },
      ],
    },
    {
      phaseTitle: "Ship",
      phaseWeeks: "Weeks 11–13",
      items: [
        {
          weekLabel: "Week 11",
          title: "High-Fidelity Prototyping & Go-To-Market Strategy",
          desc: "Pricing, positioning, interactive prototypes",
        },
        {
          weekLabel: "Weeks 12–13",
          title: "Pricing, Monetization & Product Metrics",
          desc: "Conversion flows, paywalls, KPIs",
        },
      ],
    },
    {
      phaseTitle: "Capstone & Graduation",
      phaseWeeks: "Weeks 12–16",
      items: [
        {
          weekLabel: "Week 12",
          title: "Capstone Launch",
          desc: "Brief revealed, cross-functional teams formed",
        },
        {
          weekLabel: "Week 14",
          title: "Portfolio Creation & Personal Branding",
          desc: "PM case study, design portfolio, online presence",
        },
        {
          weekLabel: "Week 15",
          title: "Industry Deep Dives & Guest Practitioner Sessions",
          desc: "Market dynamics, regulatory context, live critique",
        },
        {
          weekLabel: "Week 16",
          title: "Capstone Presentations & Graduation",
          desc: "Live demos, portfolio walkthrough, feedback",
        },
      ],
    },
  ],

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Product Management Fundamentals",
      unitTag: "Product knowledge, Product Strategy, Team Leadership",
      unitDescription: `
      Covers the foundational aspects of product management, including the role and
      responsibilities of a product manager. Introduces key product management
      methodologies, the pillars of product management, and the application of
      human-centered design to solve user challenges effectively.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Role and expectations of a product manager",
          featureDescription: `Explains the critical responsibilities of a
          product manager, including managing the product lifecycle, aligning team efforts with
          business goals, and ensuring customer satisfaction through well-defined objectives.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Apply product management methodologies and pillars of product management",
          featureDescription: `Introduces the foundational frameworks of product management, such as Agile, Lean,
          and Waterfall, emphasizing how to choose and apply the right methodology for specific
          scenarios.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Understand human centred design and its application",
          featureDescription: `Focuses on the principles of
          designing products that cater to user needs, preferences, and pain points. Discusses
          methods to integrate empathy into the product development process.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Design Thinking",
      unitTag: "Design thinking, Empathy mapping, User research, User Persona",
      unitDescription: `
      Focuses on transitioning from initial ideas to creating and testing prototypes.
      Emphasizes the importance of gathering feedback and iterating on ideas. Includes
      practical guidance on writing a Product Requirement Document (PRD).
        `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Understanding how to move from virtual ideas to creating and testing prototypes",
          featureDescription: `Guides participants through the journey of brainstorming innovative
          ideas and converting them into tangible prototypes. Discusses tools and
          techniques to ensure ideas are practical and actionable.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Testing ideas and getting feedback",
          featureDescription: `Teaches participants how to conduct
          usability tests, gather meaningful feedback from users, and iterate on their
          prototypes to improve functionality and user experience.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Writing of product requirement document",
          featureDescription: `Introduces the structure and
          components of a PRD, focusing on how to document product vision, features,
          and functionality in a clear and concise manner for stakeholders.
          `,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Product design for product managers",
      unitTag:
        "Product Prototyping, Wireframing, User Testing, Iterative Product Development",
      unitDescription: `
      Highlights the role of product designers in the development process and explores the
      distinctions between product design and UI/UX. Includes an overview of the product
      design process, practical use of UI/UX tools, and fundamentals of prototyping,
      wireframes, and user experience.
        `,
      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle:
            "Understand role of product designers in product development",
          featureDescription: `Explains the
          collaboration between product managers and designers, highlighting how design
          decisions impact product usability and user satisfaction.
          `,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Understand the process of product design",
          featureDescription: `Breaks down the design process,
          from user research and ideation to wireframing, prototyping, and testing,
          emphasizing its iterative nature.
          `,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Understand how product design is different from UI/UX",
          featureDescription: `Clarifies the
          distinction between product design (solving problems and defining features) and
          UI/UX (creating intuitive user interfaces and experiences).
          `,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Know the tools used in UI/UX (practicals)",
          featureDescription: `Provides hands-on experience with
          industry-standard tools like Figma, Sketch, and Adobe XD to help participants
          understand their practical applications.
          `,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Understand prototyping and wireframes",
          featureDescription: `Covers the basics of creating
          wireframes to visualize product ideas and prototypes to simulate product
          functionality before full development.
          `,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Fundamentals of user experience",
          featureDescription: `Explains key principles like usability,
          accessibility, and user-centric design, ensuring products are intuitive and meet
          user expectations.`,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Agile Methodology & Scrum Framework",
      unitTag:
        "Agile Framework, Development Process, Iterative Product Development",
      unitDescription: `
      Explores the differences between Agile principles and traditional methodologies, such as
      Waterfall, while examining their strengths and weaknesses. Delves into the Scrum
      framework, emphasizing the creation of user stories, story points, and their application in
      project planning.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Identify sequential phases in the software development process",
          featureDescription: `Explains
          the traditional step-by-step approach to software development, highlighting
          phases like requirement gathering, design, development, testing, and
          deployment.`,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Differentiate Agile principles from traditional methodologies",
          featureDescription: `Compares Agile principles with traditional methodologies like Waterfall, 
          focusing on flexibility, adaptability, and iterative improvements.`,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Compare strength and weakness of waterfall and agile approaches",
          featureDescription: `Discusses the pros and cons of both methodologies, providing 
          insights on when to use each approach based on project needs.
              `,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "Recognize the significance of Scrum in project management",
          featureDescription: `Highlights the
          key elements of Scrum, including sprints, roles (Scrum Master, Product Owner),
          and ceremonies, and how they foster collaboration and transparency.
              `,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Craft user stories and apply story points in project planning",
          featureDescription: `Teaches how to
          write user stories that capture user needs and assign story points to estimate
          effort and prioritize tasks effectively.
              `,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Prioritization techniques",
      unitTag: "Product Planning, MVPs, Prioritization Frameworks",
      unitDescription: `
      Explains the importance of prioritization in making effective decisions. Introduces various
      prioritization methods and explores the concept of Minimum Viable Product (MVP) as a
      tool for driving focus and efficiency in product development.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Understand the significance of prioritization in effective decision-making",
          featureDescription: `Explores how prioritization helps teams focus on high-impact tasks and 
          ensures resources are allocated to areas that maximize value.`,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Identify various methods employed for prioritization in decision-making process",
          featureDescription: `Introduces frameworks like MoSCoW (Must-have, Should-have,
          Could-have, Won’t-have), RICE (Reach, Impact, Confidence, Effort), and the
          Kano Model for making informed prioritization decisions.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Understand the importance of minimum viable product",
          featureDescription: `Discusses the role of
          MVPs in validating ideas, reducing time-to-market, and enabling rapid iterations
          based on user feedback
              `,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Jira",
      unitTag: "Vision and Strategy, Jira",
      unitDescription: `
      Provides a comprehensive guide to using Jira in product development. Covers task
      management, team collaboration, and how to leverage Jira’s features for effective
      workflow organization.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "How to use Jira in product development",
          featureDescription: `Provides a comprehensive guide to
          setting up Jira projects, creating tasks and user stories, managing sprints,
          tracking progress, and using Jira dashboards to improve team efficiency.`,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Product discovery",
      unitTag: "Product Discovery, Product Viability",
      unitDescription: `
      Covers the process of identifying product opportunities using a dual Agile framework.
      Focuses on evaluating methods to determine the viability of a product or feature,
      ensuring alignment with user needs and market demand.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Understand the process of identifying opportunities with a dual agile framework",
          featureDescription: `Explains how to uncover valuable product opportunities by
          combining discovery (identifying problems and user needs) and delivery
          (executing solutions) using Agile practices.`,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Evaluating methods to gauge the viability of a product or feature in a given context",
          featureDescription: `Introduces techniques like market research, competitor analysis, and
          user interviews to assess the feasibility and potential impact of a product or
          feature.
          `,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Product vision and strategy",
      unitTag: "Product Vision, Strategy, Objectives, Key Results, Roadmaps",
      unitDescription: `
      Explores the importance of vision and strategy in shaping product direction. Discusses
      how objectives, key results, and roadmaps guide development. Also examines different
      types of roadmaps and their significance in achieving strategic goals.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understand the role and vision in product direction",
          featureDescription: `Discusses how a clear product vision aligns the team’s efforts and guides long-term decision-making.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Understand role of strategy and product direction",
          featureDescription: `Explores how strategic planning ensures a product meets business objectives while addressing user needs.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Understand product objectives and key results",
          featureDescription: `Teaches how to define measurable objectives and track progress through key results.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "Understand roadmap and it's significance in product development",
          featureDescription: `Highlights the role of roadmaps in communicating timelines, priorities, and deliverables to stakeholders.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Identify various types of roadmaps",
          featureDescription: `Explains different roadmap formats, such as feature-based, timeline-based, and goal-oriented roadmaps, and their use cases.
          `,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Product metrics and API",
      unitTag: "Product Metrics, Data-Driven Insights, API Fundamentals",
      unitDescription: `
      Introduces the value of metrics in measuring product success. Covers best practices for
      connecting metrics to strategy and leveraging data-driven insights. Provides a
      foundational understanding of APIs and their role in product management.
          `,
      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Best Practices for Metrics",
          featureDescription: `Discusses how to select and track meaningful metrics
          that align with product goals.Explores the role of data in making informed product
          decisions and driving improvements.`,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Values of Data and Metrics",
          featureDescription: `Explores the role of data in making informed product decisions and driving improvements.
              `,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Connecting Metrics to Strategy",
          featureDescription: `Teaches how to link metrics to strategic objectives and measure progress effectively.`,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Fundamentals of API",
          featureDescription: `Provides a basic understanding of APIs, their role in
          enabling integrations, and how product managers can work with technical teams
          to leverage APIs effectively.`,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "Stakeholder management and product launch",
      unitTag:
        "Stakeholder Management, Product Marketing, Pricing Strategies, Analytics",
      unitDescription: `
      Examines strategies for managing diverse stakeholders effectively. Explores techniques
      for successful product marketing, pricing strategies, analytics, and identifying growth
      metrics. Discusses product-led marketing and best practices for launching and scaling
      products.
          `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Learn Successful Product Marketing",
          featureDescription: `Explores strategies for positioning, promoting, and communicating the value of a product to its target audience.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Apply Effective Revenue Models and Pricing Strategies",
          featureDescription: `Teaches how to select and implement pricing models that align with market demands and business goals.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Implement Analytics for Data-Driven Decision Making",
          featureDescription: `Covers how to use analytics tools to monitor product performance and make evidence-based decisions.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Analyse various strategies during product launch",
          featureDescription: `Discusses best practices for planning and executing a successful product launch.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Identify key metrics used to measure product growth",
          featureDescription: `Explores growth metrics like customer acquisition, retention, and engagement to assess product success.
          `,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Understand the concept of product-led marketing  ",
          featureDescription: `Introduces a product-first approach to marketing, where the product itself drives user acquisition and growth.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle:
            "Recognize techniques to identify stakeholders involved in a project",
          featureDescription: `Teaches how to map stakeholders, understand their influence, and address their needs.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Understand strategies to effectively manage diverse types of stakeholders",
          featureDescription: `Provides methods to build relationships and communicate effectively with different stakeholder groups.
          `,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Oluwafemi Ojoko",
      coachRole: "Senior Product Manager",
      coachQuote:
        "Practical product decisions, clear frameworks and feedback you can use immediately.",
      coachDesc:
        "Learn from an experienced practitioner who brings current tools, real product situations and hard-won lessons into every class.",
    },
    {
      coachId: 2,
      coachImage: Coach1,
      coachName: "Jelil Ajao",
      coachRole: "Product Designer",
    },
    {
      coachId: 3,
      coachImage: OmodaraImage,
      coachName: "Oluwaseun Omodara",
      coachRole: "Senior Product and Digital Marketer",
    },
    {
      coachId: 4,
      coachImage: SerahmercyImage,
      coachName: "Serahmercy Olaoye",
      coachRole: "Product Management & Design Support",
    },
    {
      coachId: 5,
      coachImage: AmandaImage,
      coachName: "Amanda Iyoha",
      coachRole:
        "Business Analysis, Project Management & Cybersecurity Support",
    },
  ],

  learningModelsHeading: "Learn by Building",
  learningModelsSubtitle:
    "A 16-week experiential journey, delivered on Saturdays, designed to mirror how top product teams work in the real world.",

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learn through real problems.",
      modelDescription:
        "Tackle practical scenarios, not abstract exercises, to sharpen your judgment and decision-making.",
    },
    {
      modelId: 2,
      modelIcon: BuildingImage,
      modelTitle: "Build with a team",
      modelDescription:
        "Collaborate across functions to create and test real products from concept to prototype.",
    },
    {
      modelId: 3,
      modelIcon: AlunmiImage,
      modelTitle: "Own your progress",
      modelDescription:
        "Balance independent practice with live instructor-led sessions to accelerate mastery.",
    },
    {
      modelId: 4,
      modelIcon: SupportImage,
      modelTitle: "Get expert feedback",
      modelDescription:
        "Receive actionable guidance from seasoned PMs and designers, ensuring your work meets industry standards.",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: AdeolaImage,
      source: "google",
      firstname: "Adeola",
      lastname: "Adebayo Matthews",
      company: "",
      testimony: `
      Had a product management training with Utiva anchored by Oluwafemi Ojoko.
      Training was practical and hands-on with real life case studies, which made
      the training relatable. Overall, it was an excellent learning experience.
      `,
    },
    {
      id: 2,
      linkedIn: "",
      image: OttahImage,
      source: "google",
      firstname: "Ottah",
      lastname: "Tiana",
      company: "",
      testimony: `
      My trainer was Mr Ojoko Oluwafemi and my course was product management.
      Utiva has been a great learning platform; learning is made very easy, and
      students are carried along. The trainers are very easy to communicate with,
      and I love that the classes are interactive.
      `,
    },
    {
      id: 3,
      linkedIn: "",
      image: OluwabukunmiImage,
      source: "google",
      firstname: "Oluwabukunmi",
      lastname: "Kikiowo",
      company: "Sterling",
      testimony: `
      I would like to sincerely appreciate Utiva for delivering an insightful and
      impactful Product Management and Development Training Programme. The training
      was well-structured, practical, and highly engaging, providing valuable knowledge
      on product strategy, customer-centric thinking, product lifecycle management,
      market research, and product development processes. As a participant from Sterling,
      I found the sessions extremely relevant to today's dynamic business environment.
      Special recognition to Oluwafemi Ojoko for his active participation and commitment
      throughout the programme.
      `,
    },
    {
      id: 4,
      linkedIn: "",
      image: PaulImage,
      source: "google",
      firstname: "Paul",
      lastname: "Olatoye",
      company: "Sterling Bank",
      testimony: `
      I attended a Product Management Training with Utiva organized by my company,
      Sterling Bank. It was a very insightful and engaging training. The facilitator
      Oluwafemi Ojoko was calm, interactive, and well versed in the subject area. He
      gave room for contributions, taught within the context of what we do at the bank,
      and gave relatable examples. Thumbs up!
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: MoziaImage,
      source: "google",
      firstname: "Mozia",
      lastname: "Doris Chukwudumebi",
      company: "FLN Foundation Sponsorship",
      testimony: `
      My experience so far in product management class has been both insightful and
      practical, thanks to FLN Foundation sponsorship, with Mr Oluwafemi Ojoko. I've
      learned that product management is not just about building ideas, but about
      understanding real user problems and finding the best way to solve them. Concepts
      like TAM, SAM, and SOM have helped me understand how to evaluate the potential of
      a product rather than just assuming it will work.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: GabrielImage,
      source: "google",
      firstname: "Gabriel",
      lastname: "Fiona",
      company: "",
      testimony: `
      I had an excellent learning experience in the Product Management course at Utiva,
      thanks to my instructor, Oluwafemi Ojoko. He is highly knowledgeable, patient, and
      passionate about ensuring every student truly understands the concepts. What stood
      out most was his willingness to go the extra mile — he organized a special class
      dedicated to Jira, breaking it down in a very practical and beginner-friendly way.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: MercyImage,
      source: "google",
      firstname: "Mercy",
      lastname: "",
      company: "FLN Foundation Sponsorship",
      testimony: `
      Thanks to FLN Foundation sponsorship, Product Management classes at Utiva with
      Mr. Oluwafemi Ojoko and Project Management with Mrs Oba Oghenekome has been
      engaging, enlightening, motivating and thought-provoking. Overall, wonderful.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: KehindeImage,
      source: "google",
      firstname: "Kehinde",
      lastname: "Obaleye",
      company: "",
      testimony: `
      My experience at Utiva was both enriching and impactful. I studied Product
      Management under the guidance of my trainer, Mr Femi Daniel Ojoko, whose teaching
      style was clear, practical, and very engaging. He made complex concepts easy to
      understand and ensured that every session was interactive and valuable.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: EresabaImage,
      source: "google",
      firstname: "Eresaba",
      lastname: "Emmanuel",
      company: "",
      testimony: `
      Utiva is a great place to enhance your skills. I am currently taking the Product
      Management course taught by Oluwafemi Ojoko and it's been life changing, from the
      space to the presentation and the interaction. Feels like home.
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: OlutayoImage,
      source: "google",
      firstname: "Olutayo",
      lastname: "Owolabi",
      company: "FLN Foundation Sponsorship",
      testimony: `
      I got a scholarship from FLN to study Product and Project Management at Utiva and
      I can say it has been wonderful and impactful so far. Mr Oluwafemi Ojoko is an
      amazing instructor for Product Management — he breaks down every topic into simple,
      understandable concepts and every class has been impactful.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: IsaacImage,
      source: "google",
      firstname: "Isaac",
      lastname: "Olugbenga Ifeanyi",
      company: "",
      testimony: `
      I enrolled at Utiva for the Product Management course and I always look forward to
      the live classes with the coach Mr. Oluwafemi Ojoko — always an insightful and
      knowledgeable session that leaves you wanting more. This is actually the first time
      I would be taking a course where the facilitators call and text me to check up on
      my progress and provide encouragement.
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: KabariImage,
      source: "google",
      firstname: "Kabari",
      lastname: "Sambaris",
      company: "FLN Foundation Sponsorship",
      testimony: `
      My experience so far has been amazing. I am grateful to FLN Foundation for the
      opportunity to learn Product and Project Management at Utiva. My instructor Mr.
      Oluwafemi Ojoko and Oba Oghenekome have also been a part of this success. They are
      not just good teachers but also good leaders — I am proud to be their student.
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: SolomonImage,
      source: "google",
      firstname: "Solomon",
      lastname: "Oladejo",
      company: "",
      testimony: `
      I highly recommend Utiva's Product Management program, especially with Oluwafemi
      Ojoko as a coach. He is patient, knowledgeable, and always willing to go the extra
      mile to support students. The skills I gained have been invaluable to my career.
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: OladeleImage,
      source: "google",
      firstname: "Oladele",
      lastname: "Tosin Micheal",
      company: "",
      testimony: `
      My Product Management journey at Utiva Tech School, tutored by Mr. Ojoko Oluwafemi
      Daniel, has been nothing short of amazing! Each session is practical, engaging, and
      filled with real-world insights. I've gained a clearer understanding of how to build
      products that truly meet user needs.
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: JorshImage,
      source: "google",
      firstname: "Jorsh",
      lastname: "Babatope",
      company: "",
      testimony: `
      My experience at the Utiva Product Management Bootcamp was outstanding. Oluwafemi
      Ojoko is an exceptional coach whose guidance, clarity, and real-world insights made
      the learning process both practical and inspiring. I left the program feeling
      confident and ready to take on product challenges.
      `,
    },
    {
      id: 16,
      linkedIn: "",
      image: OwoeyeImage,
      source: "google",
      firstname: "Owoeye",
      lastname: "Damilola",
      company: "",
      testimony: `
      Utiva gave me the platform to learn Product Management, but what made the experience
      truly impactful was being coached by Oluwafemi Ojoko. He simplified complex topics,
      shared real-world insights, and guided me with patience. I now feel more confident
      and prepared for my product management journey.
      `,
    },
    {
      id: 17,
      linkedIn: "",
      image: OnyedinmaImage,
      source: "google",
      firstname: "Onyedinma",
      lastname: "Okwechime",
      company: "",
      testimony: `
      I had a great learning experience during my Product Management training at Utiva.
      Mr. Oluwafemi Ojoko was an excellent instructor — patient, knowledgeable, and always
      ready to support. His teaching made the entire journey both impactful and enjoyable.
      `,
    },
    {
      id: 18,
      linkedIn: "",
      image: DamilolaKImage,
      source: "google",
      firstname: "Damilola",
      lastname: "Kareem",
      company: "",
      testimony: `
      Oluwafemi Ojoko as a coach definitely makes a learning journey easier and better.
      His teaching is always practical, clear, and tied to real industry cases. I'm sure
      you won't regret attending Utiva's Product Management program.
      `,
    },
    {
      id: 19,
      linkedIn: "",
      image: OluwaseunImage,
      source: "google",
      firstname: "Oluwaseun",
      lastname: "Faith",
      company: "",
      testimony: `
      It has been a great experience learning on Utiva. I applied for the Product
      Management course and the trainer Mr. Oluwafemi Ojoko has been very helpful.
      `,
    },
    {
      id: 20,
      linkedIn: "",
      image: OgunrinolaImage,
      source: "google",
      firstname: "Ogunrinola",
      lastname: "Boluwatife Joseph",
      company: "",
      testimony: `
      I highly recommend Utiva and Oluwafemi Ojoko to anyone who wants to transition into
      product management. The program was practical and hands-on, and his coaching made
      all the difference.
      `,
    },
  ],

  portofolio: {
    title: "Build a Portfolio That Opens Doors",
    description: `
    Capstone project includes:
    `,
    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
    deliverables: [
      "Problem Statement + Persona",
      "PRD with user stories & acceptance criteria",
      "Design System + Component Library",
      "User Flows + Wireframes",
      "High-Fidelity Prototype",
      "Product Roadmap + OKRs",
      "GTM Strategy, Monetization, Metrics Dashboard",
      "PM Case Study & Design Portfolio Entry",
    ],
  },

  certification: {
    title: "Earn a Utiva Product Management Certification",
    description: `
    Upon completing Utiva's Product Management Course, you'll receive an 
    industry-recognized, professional Product Management certification 
    to share with your network and showcase all that you've learned. 
    Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://www.youtube.com/embed/M3EwmTtWvLo",
  // videoTestimonial: "https://www.youtube.com/embed/1MK1qZFJYH0",
  videoTestimonial: "https://www.youtube.com/embed/39H2ZbP1D1k",
  videoPreviewImage: ProductMgtPreview,

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};

const AccordionItem = ({ indexLabel, title, desc, tag, defaultOpen }) => (
  <details
    open={defaultOpen}
    className="group border-b border-[#DFE6F7] [&::-webkit-details-marker]:hidden"
  >
    <summary className="cursor-pointer list-none flex items-center gap-3 py-5">
      <span className="text-primary text-sm font-extrabold w-18 flex-none">
        {indexLabel}
      </span>
      <strong className="text-[#1E2027] group-open:text-primary text-base md:text-lg flex-1 min-w-0">
        {title}
      </strong>
      <b
        aria-hidden="true"
        className="text-primary text-2xl font-normal transition-transform group-open:rotate-45 w-6 flex-none text-right"
      >
        +
      </b>
    </summary>
    <div className="pb-6 md:pl-[56px] md:pr-12">
      {desc && (
        <p className="text-[#565656] text-sm md:text-base leading-relaxed mb-2">
          {desc}
        </p>
      )}
      {tag && <small className="text-primary text-sm font-bold">{tag}</small>}
    </div>
  </details>
);

const PhasedCurriculum = ({ phases }) =>
  phases.map((phase, phaseIndex) => (
    <div key={phase.phaseTitle} className="pt-7 first:pt-0">
      <div className="flex items-baseline justify-between gap-4 mb-1">
        <h3 className="text-primary font-bold text-base md:text-lg">
          {phase.phaseTitle}
        </h3>
        <span className="text-[#565656] text-xs whitespace-nowrap">
          {phase.phaseWeeks}
        </span>
      </div>
      <div>
        {phase.items.map((item, i) => (
          <AccordionItem
            key={item.weekLabel}
            indexLabel={item.weekLabel}
            title={item.title}
            desc={item.desc}
            defaultOpen={phaseIndex === 0 && i === 0}
          />
        ))}
      </div>
    </div>
  ));

const FlatCurriculum = ({ outlines }) =>
  outlines.map((outline, i) => (
    <AccordionItem
      key={outline.unitId}
      indexLabel={String(outline.unitId).padStart(2, "0")}
      title={outline.unitTitle}
      desc={outline.unitDescription}
      tag={outline.unitTag}
      defaultOpen={i === 0}
    />
  ));

const CourseWhatYouWillLearnSection = ({ selectedCourseData }) => {
  const phases = selectedCourseData?.curriculumPhases;
  const outlines = selectedCourseData?.courseOutlines;

  const unitCount = phases
    ? phases.reduce((sum, phase) => sum + phase.items.length, 0)
    : outlines?.length || 0;

  if (!phases?.length && !outlines?.length) return null;

  return (
    <section id="curriculum" className="bg-white">
      <div className="border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-card mb-8 p-6 md:p-9">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
          <h2 className="text-primary font-bold text-2xl md:text-4xl tracking-tight m-0">
            {selectedCourseData?.curriculumHeading || "Curriculum"}
          </h2>
          <div className="flex flex-wrap gap-2">
            <span className="bg-[#F0F5FF] text-primary rounded-full px-3 py-1.5 text-[14px] font-semibold">
              {unitCount} Units
            </span>
            <span className="bg-[#F0F5FF] text-primary rounded-full px-3 py-1.5 text-[14px] font-semibold">
              {selectedCourseData?.duration}
            </span>
            <span className="bg-[#F0F5FF] text-primary rounded-full px-3 py-1.5 text-[14px] font-semibold">
              Live + Self-paced
            </span>
          </div>
        </div>

        <div className="border-t border-[#DFE6F7] mt-6">
          {phases?.length > 0 ? (
            <PhasedCurriculum phases={phases} />
          ) : (
            <FlatCurriculum outlines={outlines} />
          )}
        </div>
      </div>
    </section>
  );
};

export default CourseWhatYouWillLearnSection;
